import apiClient from '../../services/api';
import { API_ENDPOINTS } from '../../config/api';
import { wallDateKey, wallDateTime } from '../../utils/wallClock';
import { isHelp, lessonChildren, lessonRevenue } from '../../utils/lessonTypes';
export const pad = value => String(value).padStart(2, '0');
export const localDateKey = wallDateKey;
export const localDateTime = value => wallDateTime(value).slice(0, 16);
export const monthOf = value => localDateKey(value).slice(0, 7);
export function addDays(value, count) { const d = new Date(value); d.setDate(d.getDate() + count); return d; }
export function startOfWeek(value) { const d = new Date(value); d.setHours(0, 0, 0, 0); return addDays(d, -((d.getDay() + 6) % 7)); }
export const monthBounds = month => { const [y, m] = month.split('-').map(Number); return { start: new Date(y, m - 1, 1), end: new Date(y, m, 1) }; };
export const inPeriod = (lesson, start, end) => { const time = wallDateTime(lesson.starts_at); return time >= wallDateTime(start) && time < wallDateTime(end); };
export const totalsFor = lessons => lessons.reduce((total, lesson) => ({ count: total.count + (isHelp(lesson) ? 0 : 1), helpCount: total.helpCount + (isHelp(lesson) ? 1 : 0), paid: total.paid + lessonChildren(lesson, 'paid_children'), trial: total.trial + lessonChildren(lesson, 'trial_children'), revenue: total.revenue + lessonRevenue(lesson), salary: total.salary + (Number(lesson.teacher_salary) || 0) }), { count: 0, helpCount: 0, paid: 0, trial: 0, revenue: 0, salary: 0 });
export const weekLabel = value => {
  const end = addDays(value, 6);
  if (value.getMonth() === end.getMonth()) return `${value.getDate()}–${end.toLocaleDateString('ru-RU', { day: 'numeric', month: 'long' })}`;
  return `${value.toLocaleDateString('ru-RU', { day: 'numeric', month: 'short' })} – ${end.toLocaleDateString('ru-RU', { day: 'numeric', month: 'short' })}`;
};
export function weeksOfMonth(month) {
  const { start, end } = monthBounds(month), weeks = [];
  for (let week = startOfWeek(start); week < end; week = addDays(week, 7)) weeks.push(week);
  return weeks;
}
export function calendarRequestPeriod(month, week) {
  const { start, end } = monthBounds(month);
  return { start: week < start ? week : start, end: addDays(week, 7) > end ? addDays(week, 7) : end };
}
export async function fetchCalendarLessons(month, week, filters, signal) {
  const { start, end } = calendarRequestPeriod(month, week);
  const params = new URLSearchParams({ start: `${localDateKey(start)}T00:00:00`, end: `${localDateKey(end)}T00:00:00`, limit: '500', sort: 'starts_at', order: 'asc' });
  Object.entries(filters).forEach(([key, value]) => { if (value) params.set(key, value); });
  const all = [];
  for (let offset = 0; ; offset += 500) {
    const response = await apiClient.get(`${API_ENDPOINTS.LESSONS}?${params}&offset=${offset}`, { signal });
    if (!response.data?.ok) throw new Error('Не удалось загрузить занятия');
    const data = response.data.data;
    const items = Array.isArray(data?.items) ? data.items : Array.isArray(data) ? data : null;
    if (!items) throw new Error('Не удалось загрузить занятия');
    all.push(...items);
    if (items.length < 500) return all;
  }
}
export const lessonTopic = lesson => {
  if (isHelp(lesson)) return 'Помощь';
  if (['PLAN', 'REPEAT', 'SKIP_TO_NEXT'].includes(lesson.curriculum_mode) && lesson.curriculum_lesson_name) return lesson.curriculum_lesson_name;
  return lesson.is_creative ? 'Творческое занятие' : lesson.instruction_name || (lesson.curriculum_mode?.startsWith('OFF_PLAN') ? 'Внеплановое занятие' : lesson.curriculum_lesson_name || 'Без инструкции');
};
export function teacherColor(lesson) {
  const raw = String(lesson.teacher_color || '').trim();
  return /^#?[0-9a-f]{6}$/i.test(raw) ? `#${raw.replace('#', '')}` : 'var(--color-secondary)';
}
